export default __webpack_public_path__ + "static/media/financeanalysis.b499a8be.jpg";